export const iconFontAwesomeMapsCar = (
	<i className="fa-solid fa-car"></i>
);
